export const GET_BENEFICIARY_TOKENIZATION_PAGE_START =
  'GET_BENEFICIARY_TOKENIZATION_PAGE_START';
export const GET_BENEFICIARY_TOKENIZATION_PAGE_SUCCESS =
  'GET_BENEFICIARY_TOKENIZATION_PAGE_SUCCESS';
export const GET_BENEFICIARY_TOKENIZATION_PAGE_FAIL =
  'GET_BENEFICIARY_TOKENIZATION_PAGE_FAIL';
export const GET_PAYOUT_METHOD_TYPES_START = 'GET_PAYOUT_METHOD_TYPES_START';
export const GET_PAYOUT_METHOD_TYPES_SUCCESS = 'GET_PAYOUT_METHOD_TYPES_SUCCESS';
export const GET_PAYOUT_METHOD_TYPES_FAIL = 'GET_PAYOUT_METHOD_TYPES_FAIL';
export const RESET_PAYOUT_METHOD_TYPES = 'RESET_PAYOUT_METHOD_TYPES';
export const GET_PAYOUT_REQUIRED_FIELDS_START = 'GET_PAYOUT_REQUIRED_FIELDS_START';
export const GET_PAYOUT_REQUIRED_FIELDS_SUCCESS = 'GET_PAYOUT_REQUIRED_FIELDS_SUCCESS';
export const GET_PAYOUT_REQUIRED_FIELDS_FAIL = 'GET_PAYOUT_REQUIRED_FIELDS_FAIL';
export const RESET_PAYOUT_REQUIRED_FIELDS = 'RESET_PAYOUT_REQUIRED_FIELDS';
export const UPDATE_PAYOUT_REQUIRED_FIELDS = 'UPDATE_PAYOUT_REQUIRED_FIELDS';
export const CREATE_BENEFICIARY_START = 'CREATE_BENEFICIARY_START';
export const CREATE_BENEFICIARY_SUCCESS = 'CREATE_BENEFICIARY_SUCCESS';
export const CREATE_BENEFICIARY_FAIL = 'CREATE_BENEFICIARY_FAIL';
export const UPDATE_BENEFICIARY_TOKENIZATION_PAGE_STATUS =
  'UPDATE_BENEFICIARY_TOKENIZATION_PAGE_STATUS';
export const SET_ALL_BENEFICIARY_DATA_FETCHED = 'SET_ALL_BENEFICIARY_DATA_FETCHED';
